import * as ActionTypes from './ActionTypes';
import DeliveredImagesGalleryApi from './DeliveredImagesGalleryApi';

export function getImagesSucceeded(result: any) {
    return { type: ActionTypes.GET_IMAGES_SUCCESS, result: result };
}

export function getImages(
    reference: string
): (dispatch: (result: any) => void, getState: any) => any {
    return function (dispatch: (result: any) => void, getState: any) {
        return DeliveredImagesGalleryApi.getImages(reference).then((result: any) => {
            dispatch(getImagesSucceeded(result));
        });
    };
}
